var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('div',_vm._l((_vm.productInfo),function(item,index){return _c('AddToCart',{key:index,attrs:{"id":item.sku}})}),1),_vm._v(" "),_c('AddToCart',{attrs:{"id":"142997"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }